export default __webpack_public_path__ + "static/media/depts.d2f9ade5.png";